import { VisibilityRounded } from "@mui/icons-material";
import { Avatar, Button, IconButton, Tooltip } from "@mui/material";
import { Box } from "@mui/system";
import React from "react";
import { useEffect } from "react";
import { useState } from "react";
import { connect } from "react-redux";
import { useNavigate } from "react-router-dom";
import { Alert, Dialog, DynamicTable } from "../../layout";
import * as actions from "../../api/actions/pos";
import { useContext } from "react";
import { AppContext } from "../../App";
import ViewDetails from "./ViewDetails";
import { IsEmptyObj } from "../../hooks/Method";
import { useTranslation } from "react-i18next";
import { action, controller } from "../../api/Server";
import { no_img } from "../../assets";

const Inventory = () => {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const { settings, setPageTitle, authUser } = useContext(AppContext);
  const [viewData, setViewData] = useState({});
  const [showForm, setShowForm] = useState(false);
  const [invs, setInvs] = useState([]);
  const [tblData, setTblData] = useState([]);
  const [access, setAccess] = useState({});
  const [alert, setAlert] = useState({
    isOpen: false,
    type: "",
    title: "",
    subTitle: "",
  });

  useEffect(() => {
    setPageTitle(t("inventories"));
    if (
      authUser &&
      authUser.featuresAccess &&
      authUser.featuresAccess.inventory
    )
      setAccess({ ...authUser.featuresAccess.inventory });
    return () => {};
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [authUser]);

  const handleAddEdit = (val) => {
    navigate(`inventory-form/${val.id}`);
  };

  const handleView = (data) => {
    setViewData(data);
    setShowForm(!showForm);
  };

  const ActionComp = (props) => (
    <Box>
      {access.isHaveViewAccess && (
        <Tooltip arrow title={t("view")}>
          <IconButton
            onClick={() => handleView(props)}
            size="small"
            className="btn-primary mr-5"
          >
            <VisibilityRounded className="fs-18 m-2" />
          </IconButton>
        </Tooltip>
      )}
      {/* {access.isHaveDeleteAccess && (
        <Tooltip arrow title={t("delete")}>
          <IconButton
            onClick={() => handleDlt(props.id)}
            size="small"
            className="error-color"
          >
            <ClearRounded className="fs-18 m-2" />
          </IconButton>
        </Tooltip>
      )} */}
    </Box>
  );

  const HeaderComp = () => (
    <div className="d-flex flex-wrap g-5">
      {access.isHaveAddAccess && (
        <Button
          onClick={handleAddEdit}
          sx={{
            width: { md: "180px", xs: "100%" },
          }}
        >
          {t("addInventory")}
        </Button>
      )}
    </div>
  );

  useEffect(() => {
    setTblData([
      ...invs.map((j) => ({
        ...j,
        prodInfo: (
          <div className="d-flex g-10">
            <Avatar
              src={j.prodImgSrc ? j.prodImgSrc : no_img}
              alt="Product"
              variant="rounded"
              sx={{ width: 45, height: 45 }}
            />
            <div className="d-grid g-2">
              <span>{j.name}</span>
              <span className="fs-12 fw-5">{j.barcode}</span>
            </div>
          </div>
        ),
        catInfo: (
          <div className="d-grid g-2">
            <span>{j.categoryName}</span>
            {j.subcategoryName && (
              <span>
                {" > "} {j.subcategoryName}
              </span>
            )}
          </div>
        ),
        inv: (
          <div className="d-grid fs-14 fw-5">
            <span style={{ borderBottom: "1px solid var(--grayMD-color)" }}>
              Inventory: {j.inInventory}
            </span>
            <span>
              Value: {settings?.curSymbol} {j.InvValue || 0}
            </span>
          </div>
        ),
        purchPrice: (
          <span>
            {settings?.curSymbol} {j.purchPrice}
          </span>
        ),
        sellPrices: <span className="fw-5">{j.sellPrices}</span>,
      })),
    ]);

    return () => {};
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [invs]);

  return (
    <>
      <DynamicTable
        records={tblData}
        setRecords={setInvs}
        endpointKey={controller.Inventory + action.GetAllByStore}
        exportEndpoint={controller.Inventory + action.ExportInventory}
        ActionComp={ActionComp}
        HeaderComp={HeaderComp}
        enableExport={access.isHaveExportAccess}
        headers={[
          { id: "actions", label: t("actions") },
          { id: "prodInfo", label: t("product") },
          { id: "catInfo", label: t("Category") },
          { id: "inv", label: t("inventory") },
          { id: "purchPrice", label: t("purchasePrice") },
          { id: "sellPrices", label: t("sellPrice") },
        ]}
      />

      {/* Alert  */}
      <Alert alert={alert} setAlert={setAlert} />
      {/* Edit Dialog */}
      <Dialog show={showForm} maxWidth="lg" onClose={false}>
        {!IsEmptyObj(viewData) && (
          <ViewDetails {...{ setShowForm, viewData }} />
        )}
      </Dialog>
    </>
  );
};

const mapStateToProps = (state) => ({
  _list: state.pos.list,
  _type: state.pos.type,
  _defStore: state.pos.defStore,
});

const mapActionToProps = {
  _getById: actions.getById,
  _delete: actions.Delete,
  _clear: actions.clear,
};

export default connect(mapStateToProps, mapActionToProps)(Inventory);
